var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystemAlertaHorari(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0C13.18 0 17 3.82 17 8.5S13.18 17 8.5 17 0 13.18 0 8.5 3.82 0 8.5 0zM3.336 7.369a.53.53 0 0 0-.41.194l-.92.919-.06.07-.046.086a.53.53 0 0 0 .105.595l.074.061.08.046c.197.09.436.054.597-.107l.061-.062.017.22a5.73 5.73 0 0 0 1.661 3.501 5.735 5.735 0 0 0 4.082 1.69 5.76 5.76 0 0 0 5.115-3.096.53.53 0 1 0-.94-.493 4.7 4.7 0 0 1-4.175 2.528l-.215-.005-.22-.015a4.718 4.718 0 0 1-4.255-4.253L3.883 9.2l.033.034.071.059.075.043a.53.53 0 0 0 .605-.853l-.938-.939-.063-.058-.078-.051a.518.518 0 0 0-.252-.065zm5.03-1.974a.607.607 0 0 0-.607.608V8.75l.009.1.024.094a.6.6 0 0 0 .21.293l1.831 1.373.074.047.097.042a.604.604 0 0 0 .68-.212l.053-.083.038-.089a.608.608 0 0 0-.213-.678L8.974 8.445V6.003l-.007-.096-.025-.096a.606.606 0 0 0-.575-.416zm.057-2.678a5.76 5.76 0 0 0-5.115 3.096.53.53 0 1 0 .94.493 4.7 4.7 0 0 1 4.175-2.528l.215.005.22.015a4.718 4.718 0 0 1 4.255 4.253l.003.048-.032-.032-.071-.06-.086-.046a.53.53 0 0 0-.594.857l.938.938.062.058.079.051a.53.53 0 0 0 .662-.129l.92-.918.06-.071.046-.086a.53.53 0 0 0-.105-.594l-.074-.062-.08-.046a.531.531 0 0 0-.597.108l-.062.06-.016-.218a5.73 5.73 0 0 0-1.661-3.502 5.735 5.735 0 0 0-4.082-1.69z",
    id: "a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#FFB642",
    fillRule: "nonzero",
    xlinkHref: "#a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemAlertaHorari);
export default __webpack_public_path__ + "static/media/systemAlertaHorari.62c46d03.svg";
export { ForwardRef as ReactComponent };